import { useEffect } from 'react';

export const useScreenOrientationChange = ({ callback }: {
  callback: (event: ScreenOrientationEventMap['change']) => void;
}) => {
  useEffect(() => {
    if (globalThis.screen && globalThis.screen.orientation) {
      globalThis.screen.orientation.addEventListener('change', callback);
    }

    return () => {
      if (globalThis.screen && globalThis.screen.orientation) {
        globalThis.screen.orientation.removeEventListener('change', callback);
      }
    };
  }, [callback]);
};
